import React, { useState } from 'react';
import axios from 'axios';
import { FaStar } from 'react-icons/fa';
import API_URL from '../api/baseURL';

const COMPLIMENTS = [
  "Service rapide",
  "Personnel amical",
  "Bonne réception",
  "Prix abordable",
  "Voiture propre",
  "Explication claire",
  "Respect des délais",
  "Réparation de qualité",
  "Pièces d'origine",
  "Très professionnel"
];

const RateWorkshopModal = ({ maintenance, onClose, onRated, token }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [selectedCompliments, setSelectedCompliments] = useState([]);

  const handleComplimentToggle = compliment => {
    setSelectedCompliments(prev =>
      prev.includes(compliment)
        ? prev.filter(c => c !== compliment)
        : [...prev, compliment]
    );
  };

  const handleSubmit = async () => {
    const maintenanceId = maintenance._id?.$oid || maintenance._id;
    const workshop =
      maintenance.workshop?._id?.$oid ||
      maintenance.workshop?._id ||
      maintenance.workshop;

    const payload = {
      maintenanceId,
      workshop,
      rating,
      comment,
      compliments: selectedCompliments
    };

    if (!comment) delete payload.comment;
    if (!selectedCompliments.length) delete payload.compliments;

    console.log('Submitting payload:', payload);

    try {
      await axios.post(
        `${API_URL}/workshop-ratings`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      onRated();
    } catch (err) {
      const status = err?.response?.status;
      const errorMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err.message ||
        "Unknown error";
      console.error('❌ Rating failed:', errorMsg);

      if (status === 409 || errorMsg.toLowerCase().includes('already rated')) {
        onRated();
        return;
      }

      alert('Failed to submit rating: ' + errorMsg);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-900 p-6 rounded shadow-lg w-full max-w-md text-gray-800 dark:text-white">
        <h3 className="text-xl font-semibold mb-4">Noter l'atelier</h3>
        <p className="mb-2 text-sm text-gray-400">
          Comment évaluez-vous le service pour : <strong>{maintenance.serviceReason || maintenance.description || "cette intervention"}</strong> ?
        </p>

        <div className="flex mb-4 space-x-1">
          {[1, 2, 3, 4, 5].map(i => (
            <FaStar
              key={i}
              size={24}
              className={`${i <= rating ? 'text-yellow-400' : 'text-gray-500'} cursor-pointer`}
              onClick={() => setRating(i)}
            />
          ))}
        </div>

        <div className="mb-4">
          <p className="mb-2 text-sm text-gray-400">Compliments (choisissez jusqu'à 4):</p>
          <div className="flex flex-wrap gap-2">
            {COMPLIMENTS.map(tag => (
              <button
                key={tag}
                type="button"
                className={`px-2 py-1 rounded border text-xs ${
                  selectedCompliments.includes(tag)
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'bg-gray-200 text-gray-700 border-gray-300'
                }`}
                onClick={() => {
                  if (
                    !selectedCompliments.includes(tag) &&
                    selectedCompliments.length >= 4
                  ) {
                    return;
                  }
                  handleComplimentToggle(tag);
                }}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <textarea
          rows="3"
          placeholder="Laissez un commentaire optionnel..."
          value={comment}
          onChange={e => setComment(e.target.value)}
          className="w-full p-2 mb-4 border rounded text-black"
        />

        <div className="flex justify-end space-x-2">
          <button onClick={onClose} className="px-3 py-1 bg-gray-600 text-white rounded">Annuler</button>
          <button
            onClick={handleSubmit}
            className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={rating === 0}
          >
            Envoyer
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateWorkshopModal;
